<template>
  <div class="DetailsSection_accordion">
    <app-accordion-list :expand-first-item="subscriptionRatePlans.length == 1 ? true : false">
      <!-- admin - customer care actions -->
      <app-accordion
        v-if="loginRole === 'admin'"
        title="customer_care_actions"
        id="customer_care_actions" >

        <template
          slot="title"
        >
          {{ $t('subscription_details.accordion.customerCareActions.title', 'Customer Care actions') }}
        </template>

        <template
          slot="body"
        >
          <subscription-customer-care-actions
            :try-buy="tryBuyRatePlan"
            :replenishment="replenishmentRatePlan"
          />
        </template>
      </app-accordion>

      <template v-if="subscriptionRatePlans.length == 1">
        <app-accordion
          v-if="showModifyAccordionForTryBuy && !isrental && !DisabledAllAccordion && !subscriptionDetails.isBCBSSubscription && !Onvz"
          title="buy_your_subscription"
          id="buy_your_subscription" >

          <template
            slot="title"
          >
            {{ $t('subscription_details.accordion.payInFull.title.buyYour', 'Buy your') }} {{ subscriptionRatePlans[0].productName }}
          </template>

          <template slot="body">
            <try-buy-pay-in-full
              :subscription-number="subscriptionNumber"
              :subscription-rate-plan="subscriptionRatePlans[0]"
              :subscription-content-product-name="subscriptionDetails.contentProductName"
            />
          </template>
        </app-accordion>

        <app-accordion
          v-else-if="showModifyAccordionForReplenishmentOnly && !DisabledAllAccordion && !subscriptionDetails.isBCBSSubscription && !Onvz"
          title="modify_your_subscription"
          data-scroll="modifyAccordion"
          id="modify_your_subscription" >

          <template
            slot="title"
          >
            {{ $t('subscription_details.accordion.payInFull.title.ModifySubscription', 'Modify subscription') }}
          </template>

          <template slot="body">
            <app-accordion-list :expand-first-item="replenishmentOnly">
              <app-accordion
                title="change_frequency"
                v-if="subscriptionDetails.ableToChangeFrequency"
                id="replenishment_change_frequency"
                @toggle="onFrequencyAccordionToggled"
                :open-pop-up="replenishmentOnly"
                class="Accordion-sub">

                <template slot="title">
                  {{ $t('subscription_details.replenishment.changeFrequency.text.change', 'Change') }}
                  {{ $t('subscription_details.replenishment.changeFrequency.text.frequency', 'frequency') }}
                </template>

                <template slot="body">
                  <replenishment-change-frequency
                    :subscription-number="subscriptionNumber"
                    :subscription-rate-plan-id="subscriptionRatePlans[0].id"
                    :billing-periods="subscriptionDetails.availableFrequenciesToChange"
                    :subscription-return-status="OnlyDeviceReturnStatus || OnlyReplenshipmentReturnStatus"
                  />
                </template>
              </app-accordion>

              <app-accordion
                title="postpone_your_product"
                v-if="subscriptionDetails.ableToPostponeReplenishment"
                id="replenishment_postpone"
                @toggle="onPostponeAccordionToggled"
                :close-pop-up="replenishmentOnly && !subscriptionDetails.shippingConfirmed"
                class="Accordion-sub">

                <template slot="title">
                  {{ $t('subscription_details.replenishment.postpone.title', 'Postphone next shipment') }}
                </template>

                <template slot="body">
                  <replenishment-postpone
                    :subscription-number="subscriptionNumber"
                    :subscription-rate-plan-id="subscriptionRatePlans[0].id"
                    :subscription-return-status="OnlyDeviceReturnStatus || OnlyReplenshipmentReturnStatus"
                  />
                </template>
              </app-accordion>

              <app-accordion
                title="order_additional_onetime_replenishment"
                v-if="subscriptionRatePlans[0].allowOneTimeReplenishment"
                id="replenishment_onetime"
                :close-pop-up="replenishmentOnly && !subscriptionDetails.shippingConfirmed"
                class="Accordion-sub" >
                <template slot="title">
                  {{ $t('subscription_details.replenishment.additional.oneTime.button', 'Order additional one-time replenishment') }}
                </template>
                <template slot="body">
                  <replenishment-one-time-order
                    :subscription-number="subscriptionNumber"
                    :subscription-rate-plan-id="subscriptionRatePlans[0].id"
                  />
                </template>
              </app-accordion>

              <app-accordion
                v-if="subscriptionRatePlans[0].allowShippingNow"
                title="shipping_now_replenishment"
                id="replenshipment_shipping_now"
                @toggle="onShippingNowAccordionToggled"
                :close-pop-up="replenishmentOnly && !subscriptionDetails.shippingConfirmed"
                class="Accordion-sub" >
                <template slot="title">
                  {{ $t('subscription_details.replenishment.shippingNow.title', 'Send next shipping now') }}
                </template>

                <template slot="body">
                  <replenishment-shipping-now
                    :subscription-number="subscriptionNumber"
                    :subscription-rate-plan-id="subscriptionRatePlans[0].id"
                    :subscription-return-status="OnlyDeviceReturnStatus || OnlyReplenshipmentReturnStatus"
                    :shipping-frequency="subscriptionRatePlans[0].shippingFrequency"
                  />
                </template>
              </app-accordion>
              <!-- change product type -->
              <replenishment-change-product-type
                :replenishment-options="subscriptionDetails.availableOptionsToChangeReplenishment"
                :subscription-number="subscriptionNumber"
                :able-to-change-replenishment="subscriptionDetails.ableToChangeReplenishment"
                :bundle-type="!!replenishmentOnly"
              />
            </app-accordion-list>
          </template>
        </app-accordion>
      </template>

      <!-- subscriptionRatePlan.length > 1 -->
      <app-accordion
        v-else-if="isBundleRatePlan && !isrental && !DisabledAllAccordion && !subscriptionDetails.ableToResumeReplenishment && !subscriptionDetails.isBCBSSubscription && !Onvz"
        title="buy_your_subscription"
        data-scroll="modifyAccordion"
        id="buy_your_subscription" >

        <template
          slot="title"
        >
          {{ $t('subscription_details.accordion.payInFull.title.ModifySubscription', 'Modify subscription') }}
        </template>

        <template slot="body" >
          <h3 class="title title-modify-subscription">
            {{ $t('subscription_details.accordion.payInFull.subTitle', 'Subscription products & options') }}
          </h3>

          <div class="bundle-ratePlans row equal-item narrow-gutters">
            <div class="col-md-6" v-for="ratePlan in subscriptionRatePlans" :key="ratePlan.id">
              <div class="bundle-ratePlan">
                <div ref="bundle-ratePlan_basicInfo" class="bundle-ratePlan_basicInfo">

                  <product
                    :name="ratePlan.name"
                    :image="ratePlan.imageUrl"
                    :one-time-charge="ratePlan.oneTimeCharge"
                    :monthly-charge="ratePlan.monthlyCharge"
                    :quarterly-charge="ratePlan.quarterlyCharge"
                    :semi-annual-charge="ratePlan.semiAnnualCharge"
                    :specific-months-charges="ratePlan.specificMonthsCharges"
                    :shipping-frequency="!(ratePlan.modelType === 'Replenishment' && ratePlan.status === 'Cancel') ? ratePlan.shippingFrequency : null"
                    :replenishment-quantity="!(ratePlan.modelType === 'Replenishment' && ratePlan.status === 'Cancel') ? ratePlan.replenishmentQuantity : null"
                    :subscription-detail-product-status="ratePlan.status"
                    :pay-in-full-date="!(ratePlan.modelType === 'Replenishment' && ratePlan.status === 'Cancel') ? ratePlan.payInFullDate : null"
                  />
                </div>

                <div class="bundle-ratePlan_action">
                  <app-accordion-list :expand-first-item="false">
                    <app-accordion
                      :title="`buy_your_${ratePlan.productName ? ratePlan.productName.replace(/\s/gi, '_'): 'product'}`"
                      v-if="((ratePlan.modelType === 'TryBuy' || ratePlan.modelType === 'TryBuyDepreciation' || ratePlan.modelType === 'TryBuyPurchase' || ratePlan.modelType === 'TryBuyDepreciationPurchase') && !ratePlan.status && !hidePayInFull)"
                      id="ratePlan_payInFull"
                      class="Accordion-sub">

                      <template
                        slot="title"
                      >
                        {{ $t('subscription_details.accordion.payInFull.title.buyYour', 'Buy your') }} {{ ratePlan.productName ? ratePlan.productName : ratePlan.name }}
                      </template>
                      <template slot="body">
                        <try-buy-pay-in-full
                          :subscription-number="subscriptionNumber"
                          :subscription-rate-plan="ratePlan"
                          :subscription-content-product-name="subscriptionDetails.contentProductName"
                        />
                      </template>
                    </app-accordion>

                    <template v-if="ratePlan.modelType === 'Replenishment' || ratePlan.modelType === 'ReplenishmentStandard' && !ratePlan.status">
                      <app-accordion
                        :title="`change_frequency_${ratePlan.productName ? ratePlan.productName.replace(/\s/gi, '_'): 'product'}`"
                        v-if="subscriptionDetails.ableToChangeFrequency"
                        id="replenishment_change_frequency"
                        @toggle="onFrequencyAccordionToggled"
                        :open-pop-up="!subscriptionDetails.shippingConfirmed || subscriptionDetails.shippingConfirmed"
                        class="Accordion-sub">

                        <template slot="title">
                          {{ $t('subscription_details.replenishment.changeFrequency.text.change', 'Change') }}
                          {{ ratePlan.productName? ratePlan.productName: ratePlan.name }}
                          {{ $t('subscription_details.replenishment.changeFrequency.text.frequency', 'frequency') }}
                        </template>

                        <template slot="body">
                          <replenishment-change-frequency
                            :subscription-number="subscriptionNumber"
                            :subscription-rate-plan-id="ratePlan.id"
                            :billing-periods="subscriptionDetails.availableFrequenciesToChange"
                            :subscription-return-status="BundlesReturnStatus"
                          />
                        </template>
                      </app-accordion>

                      <app-accordion
                        :title="`postpone_your_${ratePlan.productName ? ratePlan.productName.replace(/\s/gi, '_'): 'product'}`"
                        v-if="subscriptionDetails.ableToPostponeReplenishment"
                        id="replenishment_postpone"
                        @toggle="onPostponeAccordionToggled"
                        :close-pop-up="!subscriptionDetails.shippingConfirmed"
                        class="Accordion-sub" >
                        <template
                          slot="title"
                        >
                          {{ $t('subscription_details.replenishment.postpone.title', 'Postphone next shipment') }}
                        </template>
                        <template slot="body">
                          <replenishment-postpone
                            :subscription-number="subscriptionNumber"
                            :subscription-rate-plan-id="ratePlan.id"
                            :subscription-return-status="BundlesReturnStatus"
                          />
                        </template>
                      </app-accordion>

                      <app-accordion
                        v-if="ratePlan.allowOneTimeReplenishment"
                        title="order_additional_onetime_replenishment"
                        id="replenishment_onetime"
                        :close-pop-up="!subscriptionDetails.shippingConfirmed"
                        class="Accordion-sub" >
                        <template slot="title">
                          {{ $t('subscription_details.replenishment.additional.oneTime.title', 'Order additional one-time replenishment') }}
                        </template>

                        <template slot="body">
                          <replenishment-one-time-order
                            :subscription-number="subscriptionNumber"
                            :subscription-rate-plan-id="ratePlan.id"
                          />
                        </template>
                      </app-accordion>

                      <app-accordion
                        v-if="ratePlan.allowShippingNow"
                        title="shipping_now_replenishment"
                        id="replenshipment_shipping_now"
                        @toggle="onShippingNowAccordionToggled"
                        :close-pop-up="!subscriptionDetails.shippingConfirmed"
                        class="Accordion-sub" >
                        <template slot="title">
                          {{ $t('subscription_details.replenishment.shippingNow.title', 'Send next shipping now') }}
                        </template>

                        <template slot="body">
                          <replenishment-shipping-now
                            :subscription-number="subscriptionNumber"
                            :subscription-rate-plan-id="ratePlan.id"
                            :subscription-return-status="BundlesReturnStatus"
                            :shipping-frequency="ratePlan.shippingFrequency"
                          />
                        </template>
                      </app-accordion>

                      <!-- change product type -->
                      <replenishment-change-product-type
                        :replenishment-options="subscriptionDetails.availableOptionsToChangeReplenishment"
                        :subscription-number="subscriptionNumber"
                        :able-to-change-replenishment="subscriptionDetails.ableToChangeReplenishment"
                        :bundle-type="!!replenishmentOnly"
                      />
                    </template>
                  </app-accordion-list>
                </div>
              </div>
            </div>
          </div>
        </template>
      </app-accordion>

      <!-- one time order list accordion -->
      <app-accordion
        v-if="(subscriptionOneTimeOrders.length > 0) && !DisabledAllAccordion && !subscriptionDetails.ableToResumeReplenishment"
        title="one_time_orders"
        id="one_time_orders" >

        <template slot="title">
          {{ $t('subscription_details.replenishment.accordion.oneTimeOrders', 'One Time Orders') }}
        </template>

        <template slot="body">
          <replenishment-one-time-order-list
            :subscription-one-time-orders="subscriptionOneTimeOrders"
          />
        </template>
      </app-accordion>

      <!-- activate discount accordion -->
      <app-accordion
        v-if="(acceptPromotion || hasDiscount) && !DisabledAllAccordion && !subscriptionDetails.ableToResumeReplenishment && !subscriptionDetails.isBCBSSubscription && !Onvz"
        title="promotion_information"
        id="promotion_information" >

        <template slot="title">
          {{ $t('subscription_details.accordion.activateDiscount.title', 'Activate discount') }}
        </template>

        <template slot="body">
          <subscription-promotions/>
        </template>
      </app-accordion>

      <!-- track order accordion-->
      <app-accordion
        v-if="!DisabledAllAccordion && !subscriptionDetails.ableToResumeReplenishment && !(isLumea && subscriptionDetails.status === 'InActive')"
        title="track_your_order"
        id="track_your_order" >

        <template slot="title">
          {{ $t('subscription_details.accordion.trackOrder.title', 'Track your order') }}
        </template>
        <template slot="body">
          <div class="TrackOrder">
            <template v-if="RatePlansWithTrackingNumber.length === 0">
              <h4 class="font-weight-bold">{{ $t('subscription_details.accordion.trackOrder.label2', 'A shipping confirmation will be sent to your email address within coming 24-48 hours.Please track the shipping status of your package with the tracking number provided.') }}</h4>
            </template>
            <template v-if="RatePlansWithTrackingNumber.length > 0">
              <h4 class="font-weight-bold">{{ $t('subscription_details.accordion.trackOrder.label', 'Tracking number') }}</h4>
              <div
                class="TrackOrder_item"
                v-for="ratePlan in RatePlansWithTrackingNumber"
                :key="ratePlan.id"
              >
                <h5 v-if="subscriptionRatePlans.length > 1" class="name">{{ ratePlan.name }}</h5>
                <a
                  class="TrackOrder_number"
                  target="_blank"
                  :href="ratePlan.carrierUrl + ratePlan.trackingNumber"
                >
                  {{ ratePlan.trackingNumber }}
                </a>
              </div>
            </template>
            <p v-else>
              {{ $t('subscription_details.accordion.trackOrder.trackingNumber.tip','trackingNumber is processing') }}
            </p>
          </div>
        </template>
      </app-accordion>

      <!-- pause subscription -->
      <div class="pause_subscription" v-if="subscriptionDetails.ableToPauseReplenishment && !subscriptionDetails.isBCBSSubscription && !Onvz">
        <template>
          <replenshipment-pause-subscription
            :subscription-number="subscriptionNumber"
          />
        </template>
      </div>

      <!-- resume subscription -->
      <div class="resumeSubscription">
        <div class="startSubscription">
          <p v-if="!subscriptionDetails.isBCBSSubscription && !Onvz && subscriptionDetails.ableToResumeReplenishment || subscriptionDetails.ableToChangeReplenishmentResumeDate" @click="popupResumeSubscription">
            {{ $t('subscription_details.accordion.resumeSubscription.button.text', 'Resume subscription') }}
          </p>
        </div>
        <app-modal name="replenishmentResume" width="545px" min-height="200px">
          <div class="v--modal-content">
            <h3 class="modal-title" v-if="subscriptionDetails.ableToResumeReplenishment">
              {{ $t('subscription_details.accordion.resumeSubscription.popUp.title', 'Please confirm to resume your subscription') }}
            </h3>

            <h3 class="modal-title" v-if="subscriptionDetails.ableToChangeReplenishmentResumeDate">
              {{ $t('subscription_details.accordion.resumeSubscription.specificDate.popUp.title', 'Please confirm to resume your subscription') }}
            </h3>

            <div class="modal-content">
              <p v-if="subscriptionDetails.ableToResumeReplenishment">
                {{ $t('subscription_details.accordion.resumeSubscription.popUp.tips', '• Payment and shipments will resume immediately.') }}
              </p>

              <p v-if="subscriptionDetails.ableToChangeReplenishmentResumeDate">
                {{ $t('subscription_details.accordion.resumeSubscription.specificDate.popUp.tips', '• Payment and shipments will resume immediately.') }}
              </p>

              <div class="modal-button-warpper modal-button">
                <app-button @click="$bus.$emit('close-modal', 'replenishmentResume')" class="cancel_openModal">
                  {{ $t('subscription_details.accordion.resumeSubscription.popUp.button.cancel', 'Cancel') }}
                </app-button>
                <app-button
                  type="submit"
                  @click.prevent="resumeSubscription.run()"
                  :is-loading="resumeSubscription.isActive"
                >
                  {{ $t('subscription_details.accordion.resumeSubscription.popUp.button.resume', 'Resume subscription') }}
                </app-button>
              </div>
            </div>
          </div>
        </app-modal>
      </div>

      <app-accordion
        title="recycling_program"
        id="recycling_program"
        class="recycling_program"
        v-if="!repairaccordian">
        <template slot="title">
          {{ $t('subscription_details.accordion.repair.title', 'Service ') }}
        </template>
        
        <template slot="body">
          <div class="TrackOrder">
           {{ $t('subscription_details.accordion.repair.title1', 'I have requested repair service ') }} 
            </div> 
        </template>
          </app-accordion>

      <app-accordion
        title="recycling_program"
        id="recycling_program"
        class="recycling_program"
        v-if="repair && detectedCulture.countryCode ==='NL'">
        <template slot="title">
          {{ $t('subscription_details.accordion.repair.title', 'Service ') }}
        </template>
        
        <template slot="body">
          <div class="TrackOrder">
          <div v-html="$t('subscription_details.accordion.repair.body', '')">
          </div>
          </div> 
          <div class="modal-button-warpper modal-button">
              <app-button
                  type="submit"
                  @click.prevent="repairSubscriptionTask.run()"                  
                >
                   {{ $t('subscription_details.accordion.resumeSubscription.popUp.button.resume1', 'Click here once you requested your repair') }} 
              </app-button>
          </div> 
        </template>     
      </app-accordion>


      <!-- Recycling program -->
      <app-accordion
        title="recycling_program"
        id="recycling_program"
        class="recycling_program"
        v-if="isEligibleForRecycleProgram">
        <template slot="title">
          {{ $t('subscription_details.accordion.recycleProgram.title', 'Recycling program') }}
        </template>
        <template slot="body">
          <div v-html="$t('subscription_details.accordion.recycleProgram.body', '')">
          </div>
        </template>
      </app-accordion>

      <!-- bundles -> cancellation -->
      <app-accordion
        title="cancellation_your_subscription"
        id="new_flow_to_cancel_subscription"
        v-if="subscriptionDetails.ableToCancel && repairaccordian && !(isLumea && subscriptionDetails.status === 'InActive')">
        <template slot="title">
          {{ $t('subscription_details.bundles.cancellation.title', 'Cancel my subscription') }}
        </template>
        <template slot="body">
          <cancellation-subscription
            :only-device="isOnlyDeviceRatePlan"
            :display-modify-button="displayModifyButton"
            :disabled-all-accordion="DisabledAllAccordion"
          />
        </template>
      </app-accordion>

      <!-- subscription return/cancel subscription accordion-->
      <app-accordion
        title="cancel_your_subscription"
        v-if="(DisplayDeviceReturnDetails || DisplayOnlyReplenshipmentReturnDetails || DisplayBundlesCancelAccordion) && !subscriptionDetails.ableToCancel && !(isLumea && subscriptionDetails.status === 'InActive')"
        id="cancel_your_subscription" >
        <template slot="title" v-if="!subscriptionDetails.replenishmentOnly && subscriptionRatePlans.length === 1 && (tryBuyReturnDetails && tryBuyReturnDetails.returnStatus === 'Returning')">
          {{ $t('subscription_details.bundles.accordion.cancel.subTitle', 'Withdraw cancellation and continue subscription') }}
        </template>
        <template slot="title" v-else-if="(subscriptionDetails.replenishmentOnly && (replenishmentReturnDetails && replenishmentReturnDetails.returnStatus === 'Returning'))">
          {{ $t('subscription_details.onlyReplenishment.accordion.cancel.subTitle', 'Withdraw cancellation and continue subscription') }}
        </template>
        <template slot="title" v-else-if="subscriptionRatePlans.length > 1 && !this.subscriptionRatePlans[1].status === 'Cancel'">
          {{ $t('subscription_details.accordion.bundles.canceled.title', 'Return your device') }}
        </template>
        <template slot="title" v-else-if="subscriptionRatePlans.replenishmentOnly && !this.subscriptionDetails.ableToCancelReplenishment">
          {{ $t('subscription_details.accordion.onlyReplenishment.canceled.title', 'Return your subscription') }}
        </template>
        <template slot="title" v-else>
          {{ $t('subscription_details.accordion.cancel.title', 'Cancel your subscription') }}
        </template>
        <template slot="body">
          <subscription-cancel-section
            :display-modify-button="displayModifyButton"
            :disabled-all-accordion="DisabledAllAccordion"
          />
        </template>
      </app-accordion>

      <!-- bundles -> withdraw accordion -->
      <app-accordion
        title="withdraw_your_subscription"
        v-if="(subscriptionRatePlans.length > 1 && (replenishmentReturnDetails && replenishmentReturnDetails.returningWithdrawable || (tryBuyReturnDetails && tryBuyReturnDetails.returningWithdrawable))) && !subscriptionDetails.isCancelled && !subscriptionDetails.isBCBSSubscription && !Onvz">
        <template slot="title">
          {{ $t('subscription_details.bundles.accordion.cancel.subTitle', 'Withdraw cancellation and continue subscription') }}
        </template>
        <template slot="body">
          <returning-withdraw
            :device="tryBuyRatePlan"
            :replenshipment="replenishmentRatePlan"
            :device-return-infos="tryBuyReturnDetails"
            :replenshipment-return-infos="replenishmentReturnDetails"
            class="return-information"
          />
        </template>
      </app-accordion>

      <!-- terms and conditions -->
      <app-accordion
        title="terms_and_conditions"
        id="terms_and_conditions"
        v-if="!DisabledAllAccordion && !subscriptionDetails.ableToResumeReplenishment"
        @toggle="onTCAccordionToggled">
        <template slot="title">
          {{ $t('subscription_details.accordion.termsAndConditons.title', 'Terms and condittions') }}
        </template>
        <template slot="body">
          <ul>
            <li v-for="(item, index) in subscriptionDetails.termsAndConditions" :key="index">
              <a
                class="termsAndConditions"
                v-if="item === 'Subscription'"
                @click.prevent.stop="previewTermsTask.run(subscriptionNumber, item)"
              >
                {{ $t('subscription_details.accordion.termsAndConditons.subscriptionTerms.linkText', 'Subscription terms') }}
              </a>
              <a
                class="termsAndConditions"
                v-if="item === 'Purchase'"
                @click.prevent.stop="previewTermsTask.run(subscriptionNumber, item)"
              >
                {{ $t('subscription_details.accordion.termsAndConditons.purchaseTerms.linkText', 'Purchase terms') }}
              </a>
            </li>
          </ul>
        </template>
      </app-accordion>

      <!-- canceled display tips -->
      <div class="startSubscription">
        <!-- cancelled only replenishment -->
        <p v-if="DisplayRestartSubscriptionForOnlyReplenshipment" @click="redictToCheckout">
          {{ $t('subscription_details.onlyReplenishment.cancelled.button', 'Restart subscription') }}
        </p>
        <!-- cancelled only device -->
        <p v-if="DisplayRestartSubscriptionForOnlyDevice" @click="redictToCheckout">
          {{ $t('subscription_details.onlyDevice.cancelled.button', 'Restart subscription') }}
        </p>
        <!-- bundle -> repl canceled -->
        <p v-if="DisplayTryBuyPayinfullAndReplCancelledRestartReplenshipmentTips && !DisplayRestartReplenshipmentButton" @click="redictToCheckout">
          {{ $t('subscription_return.cancelOrReturn.cancelled.button.text', 'Restart original subscription') }}
        </p>
        <!-- bundle -> device payinfull and repl canceled -->
        <p v-if="DisplayRestartReplenshipmentButton" @click="redictToCheckout">
          {{ $t('subscription_return.cancelOrReturn.cancelled.restartReplenshipment.button.text', 'Restart replenshipment subscription') }}
        </p>

        <p v-if="DisplayRestartReplenishment" @click="redictToCheckout">
          {{ $t('subscription_return.cancelOrReturn.cancelled.restartReplenshipment.button.text', 'Restart replenshipment subscription') }}
        </p>
      </div>
    </app-accordion-list> 
  </div>
</template>

<script>
  import Product from 'components/Product'
  import TryBuyPayInFull from 'components/TryBuyPayInFull'
  import SubscriptionCancelSection from 'components/SubscriptionCancelSection'
  import ReplenishmentCancel from 'components/ReplenishmentCancel'
  import ReplenishmentChangeFrequency from 'components/ReplenishmentChangeFrequency'
  import ReplenishmentPostpone from 'components/ReplenishmentPostpone'
  import ReplenishmentOneTimeOrder from 'components/ReplenishmentOneTimeOrder'
  import ReplenishmentOneTimeOrderList from 'components/ReplenishmentOneTimeOrderList'
  import SubscriptionPromotions from 'components/SubscriptionPromotions'
  import SubscriptionCustomerCareActions from 'components/SubscriptionCustomerCareActions'
  import DiscountBox from 'components/DiscountBox'
  import ReplenshipmentPauseSubscription from 'components/ReplenshipmentPauseSubscription'
  import ReplenishmentShippingNow from 'components/ReplenishmentShippingNow'
  import siteConfig from 'siteConfig'
  import { detectedCulture } from '@/utilities/common/culture'
  import { mapState } from 'vuex'
  import { extractErrorMessage } from '@/utilities/common'
  import Vue from 'vue'
  import returningWithdraw from 'components/SubscriptionCancelSteps/ReturningWithdraw'
  import CancellationSubscription from 'components/SubscriptionCancelSteps/CancellationSubscription'
  import { find } from 'lodash'
  import ReplenishmentChangeProductType from 'components/ReplenishmentChangeProductType'

  export default {
    name: 'subscription-details-accordion',

    components: {
      Product,
      DiscountBox,
      TryBuyPayInFull,
      ReplenishmentCancel,
      ReplenishmentChangeFrequency,
      ReplenishmentPostpone,
      ReplenishmentOneTimeOrder,
      ReplenishmentOneTimeOrderList,
      ReplenishmentShippingNow,
      SubscriptionPromotions,
      SubscriptionCustomerCareActions,
      SubscriptionCancelSection,
      ReplenshipmentPauseSubscription,
      returningWithdraw,
      CancellationSubscription,
      ReplenishmentChangeProductType,
      
    },

    props: {
      subscriptionRatePlans: {
        type: Array,
        required: true
      },

      subscriptionNumber: {
        type: String,
        required: true
      },

      subscriptionReturnStatus: {
        type: String,
        default: null
      },
      tryBuyReturnDetails: {
        type: Object,
        default: null
      },
      replenishmentReturnDetails: {
        type: Object,
        default: null
      },
      replenishmentOnly: {
        type: Boolean,
        required: true
      },

      acceptPromotion: {
        type: Boolean,
        default: false
      },

      subscriptionOneTimeOrders: {
        type: Array,
        required: true
      },

      hasDiscount: {
        type: Boolean,
        required: true
      },

      hidePayInFull: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        loginRole: window.localStorage.getItem('loginRole') || 'user',
        step1Show: false,
        currentIndex: -1,
        detectedCulture: detectedCulture,
      }
    },

    computed: {
      ...mapState('subscription', ['subscriptionDetails', 'subscriptions']),
    
       ...mapState('account', {
        profile: state => state.profile,
        paymentActivity: state => state.paymentActivity
      }),

      tryBuyRatePlan () {
        return find(this.subscriptionDetails.ratePlans, { modelType: 'TryBuy' }) ||
          find(this.subscriptionDetails.ratePlans, { modelType: 'TryBuyPurchase' }) ||
          find(this.subscriptionDetails.ratePlans, { modelType: 'TryBuyDepreciation' }) ||
          find(this.subscriptionDetails.ratePlans, { modelType: 'TryBuyDepreciationPurchase' })
      },

      replenishmentRatePlan () {
        return find(this.subscriptionDetails.ratePlans, { modelType: 'Replenishment' })
      },

      isOnlyReplenishmentRatePlan () {
        return this.subscriptionRatePlans.length === 1 &&
          (this.subscriptionRatePlans[0].modelType === 'Replenishment' || this.subscriptionRatePlans[0].modelType === 'ReplenishmentStandard') &&
          this.replenishmentReturnDetails
      },

      isOnlyDeviceRatePlan () {
        return this.subscriptionRatePlans.length === 1 &&
          (this.subscriptionRatePlans[0].modelType !== 'Replenishment' && this.subscriptionRatePlans[0].modelType !== 'ReplenishmentStandard') &&
          this.tryBuyReturnDetails
      },

      isBundleRatePlan () {
        return this.subscriptionRatePlans.length > 1
      },

      showModifyAccordionForReplenishmentOnly () {
        return this.isOnlyReplenishmentRatePlan &&
          this.subscriptionRatePlans[0].status !== 'Cancel' &&
          (this.subscriptionDetails.ableToChangeFrequency ||
          this.subscriptionDetails.ableToPostponeReplenishment ||
          this.subscriptionRatePlans[0].allowOneTimeReplenishment ||
          this.subscriptionRatePlans[0].allowShippingNow) &&
          !this.subscriptionDetails.ableToResumeReplenishment
      },

      showModifyAccordionForTryBuy () {
        return this.isOnlyDeviceRatePlan &&
          this.tryBuyReturnDetails.unreturnableReason !== 'PaidByPartner' &&
          !this.hidePayInFull
      },

      RatePlansWithTrackingNumber () {
        return this.subscriptionRatePlans.filter(ratePlan => !!ratePlan.trackingNumber)
      },

      DisabledAllAccordion () {
        if (this.isBundleRatePlan) {
          return (this.tryBuyReturnDetails && this.tryBuyReturnDetails.returnStatus === 'Returning' &&
            this.replenishmentReturnDetails && this.replenishmentReturnDetails.returnStatus === 'Returning') ||
            ((this.subscriptionRatePlans[0].status === 'PayInFull' || this.subscriptionRatePlans[0].status === 'Cancel') &&
            this.subscriptionRatePlans[1].status === 'Cancel')
        } else {
          if (this.isOnlyDeviceRatePlan) {
            return this.subscriptionRatePlans[0].status === 'Cancel' || this.tryBuyReturnDetails.unreturnableReason === 'HasReturned'
          } else if (this.isOnlyReplenishmentRatePlan) {
            return (this.subscriptionRatePlans[0].status === 'Cancel' ||
            (this.replenishmentReturnDetails.returnStatus === 'Returning'))
          }
        }
      },

      DisplayBundlesCancelAccordion () {
        if (this.isBundleRatePlan) {
          return (this.subscriptionDetails.ableToCancelReplenishment &&
            this.replenishmentReturnDetails && this.replenishmentReturnDetails.returnStatus !== 'Returning') ||
            ((this.tryBuyReturnDetails && this.tryBuyReturnDetails.returnable) ||
            (this.replenishmentReturnDetails && this.replenishmentReturnDetails.returnable)) ||
            (this.tryBuyReturnDetails && !this.tryBuyReturnDetails.returnable &&
            (this.tryBuyReturnDetails.unreturnableReason === 'PaidInFull' || this.tryBuyReturnDetails.unreturnableReason === 'InLockPeriod'))
        } else if (this.isOnlyReplenishmentRatePlan) {
          return (this.subscriptionDetails.ableToCancelReplenishment && this.replenishmentReturnDetails.returnStatus !== 'Returning') ||
            (!this.replenishmentReturnDetails.returnable &&
            (this.replenishmentReturnDetails.unreturnableReason === 'PaidInFull' || this.subscriptionDetails.reasonToDisableCancellation === 'InLockPeriod'))
        }
      },

      DisplayDeviceReturnDetails () {
        return this.isOnlyDeviceRatePlan &&
          ((this.subscriptionRatePlans[0].status !== 'Cancel' && (this.tryBuyReturnDetails.returnStatus === 'Returning' || this.tryBuyReturnDetails.returnable)) ||
          (this.tryBuyReturnDetails.unreturnableReason === 'PaidInFull' || this.tryBuyReturnDetails.unreturnableReason === 'InLockPeriod'))
      },

      DisplayOnlyReplenshipmentReturnDetails () {
        return this.isOnlyReplenishmentRatePlan &&
          (this.subscriptionRatePlans[0].status !== 'Cancel' && (this.subscriptionDetails.ableToCancelReplenishment ||
          (this.replenishmentReturnDetails.returnable || this.replenishmentReturnDetails.returningWithdrawable)))
      },

      DisplayTryBuyPayinfullAndReplCancelledRestartReplenshipmentTips () {
        return (this.isBundleRatePlan &&
          ((this.subscriptionRatePlans[0].status === 'PayInFull' || this.subscriptionRatePlans[0].status === 'Cancel') &&
          this.subscriptionRatePlans[1].status === 'Cancel'))
      },

      DisplayRestartReplenshipmentButton () {
        return this.isBundleRatePlan &&
          (this.subscriptionRatePlans[0].status === 'PayInFull') &&
          !this.subscriptionDetails.isCancelled &&
          this.subscriptionRatePlans[1].status === 'Cancel'
      },

      isrental () {
        return this.subscriptionDetails.bundleName.includes('4A') || this.subscriptionDetails.bundleName.includes('4B')
      },

      repair () {
       return find(this.subscriptionDetails.ratePlans, { isRepairable: true })
      },

      repairaccordian () {
         return find(this.subscriptionDetails.ratePlans, { repairStatus: null })
      },

      DisplayRestartReplenishment () {
        return this.isBundleRatePlan &&
          ((this.subscriptionRatePlans[1].status === 'Cancel' && this.subscriptionRatePlans[0].status !== 'Cancel' &&
          this.subscriptionRatePlans[0].status !== 'PayInFull') ||
          (this.subscriptionDetails.isCancelled && (this.tryBuyReturnDetails &&
          this.tryBuyReturnDetails.unreturnableReason !== 'SubscriptionCancelled' &&
          this.replenishmentReturnDetails && this.replenishmentReturnDetails.unreturnableReason !== 'SubscriptionCancelled')))
      },

      DisplayRestartSubscriptionForOnlyReplenshipment () {
        return this.subscriptionRatePlans[0].status === 'Cancel' &&
          this.isOnlyReplenishmentRatePlan
      },

      DisplayRestartSubscriptionForOnlyDevice () {
        return this.isOnlyDeviceRatePlan &&
          this.subscriptionRatePlans[0].status === 'Cancel'
      },

      OnlyDeviceReturnStatus () {
        return this.isOnlyDeviceRatePlan && this.tryBuyReturnDetails.returnStatus
      },

      OnlyReplenshipmentReturnStatus () {
        return this.isOnlyReplenishmentRatePlan && this.replenishmentReturnDetails.returnStatus
      },

      BundlesReturnStatus () {
        const BundlesReturnStatus = {
          tryBuyReturnStatus: this.tryBuyReturnDetails.returnStatus,
          replenishmentReturnStatus: this.replenishmentReturnDetails.returnStatus
        }
        return BundlesReturnStatus
      },

      resumeDate () {
        return `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`
      },

      displayModifyButton () {
        return ((this.isBundleRatePlan &&
          !this.subscriptionDetails.ableToResumeReplenishment &&
          !this.DisabledAllAccordion &&
          (this.subscriptionDetails.ableToChangeFrequency ||
          this.subscriptionDetails.ableToPostponeReplenishment ||
          this.subscriptionRatePlans[1].allowOneTimeReplenishment ||
          this.subscriptionRatePlans[1].allowShippingNow || this.subscriptionDetails.tryBuyHasShipped)
        ) ||
        (this.showModifyAccordionForReplenishmentOnly)) &&
          this.subscriptionDetails.shippingConfirmed &&
          !this.DisabledAllAccordion && this.subscriptionDetails.hasShipped
      },

      isLumea () {
        return this.subscriptionDetails.contentProductName.includes('Lumea') || this.subscriptionDetails.contentProductName.includes('lumea')
      },

      Onvz () {
        return this.detectedCulture.countryCode ==='NL' && this.subscriptionDetails.title.includes ('ONVZ')
      },

      isEligibleForRecycleProgram () {
        return this.isRecycleProgramEnabledOnDetectedCountry &&
          this.isSonicareProduct &&
          (this.subscriptionDetails.replenishmentOnly || this.replenishmentRatePlan) &&
          this.subscriptionDetails.shippingConfirmed
      },

      isRecycleProgramEnabledOnDetectedCountry () {
        let recycleProgramEnabledCountriesList = ['GB']

        for (let i in recycleProgramEnabledCountriesList) {
          if (detectedCulture.countryCode === recycleProgramEnabledCountriesList[i]) {
            return true
          }
        }

        return false
      },

      isSonicareProduct () {
        return this.subscriptionDetails.bundleName.toLowerCase().includes('sonicare') || this.subscriptionDetails.contentProductName.toLowerCase().includes('sonicare')
      }
    },

    methods: {
      handleRatePlanBasicInfoHeight () {
        let clientWidth = document.body.clientWidth || document.documentElement.clientWidth
        if (this.$refs['bundle-ratePlan_basicInfo'] && clientWidth >= 768) {
          let bundleRatePlanBasicInfoMaxHeight = 0
          this.$refs['bundle-ratePlan_basicInfo'].forEach(item => {
            item.style.minHeight = 0
            bundleRatePlanBasicInfoMaxHeight = Math.max(bundleRatePlanBasicInfoMaxHeight, item.clientHeight)
          })
          this.$refs['bundle-ratePlan_basicInfo'].forEach(item => {
            item.style.minHeight = bundleRatePlanBasicInfoMaxHeight + 'px'
          })
        }
      },

      redictToCheckout () {
        this.trackConversion({ name: 'interaction', description: 'button:stay_subscribed' })
        let redictBundle = this.subscriptionDetails.bundleName
        this.$router.push({
          path: '/checkout',
          query: {
            bundle: redictBundle
          }
        })
      },

      popupResumeSubscription () {
        this.$bus.$emit('open-modal', 'replenishmentResume')
      },

      closeResumeSubscription () {
        this.$bus.$emit('close-modal', 'replenishmentResume')
      },

      onTCAccordionToggled (status) {
        const description = status.expand ? 'link:down_arrow:unfold_accordion' : 'link:up_arrow:fold_accordion'
        this.trackConversion({ name: 'interaction', description: description })
      },

      onFrequencyAccordionToggled (status) {
        const description = status.expand ? 'subscription:pack_frequency:unfold' : 'subscription:pack_frequency:fold'
        this.trackConversion({ name: 'interaction', description: description })
      },

      onPostponeAccordionToggled (status) {
        const description = status.expand ? 'postphone_shipment:open' : 'postphone_shipment:closed'
        this.trackConversion({ name: 'interaction', description: description })
      },

      onShippingNowAccordionToggled (status) {
        const description = status.expand ? 'send_next_shipment_now:open' : 'send_next_shipment_now:closed'
        this.trackConversion({ name: 'interaction', description: description })
      }
    },

    mounted () {
      this.$nextTick(() => {
        this.handleRatePlanBasicInfoHeight()
      })

      const vm = this
      window.onresize = () => {
        vm.handleRatePlanBasicInfoHeight()
        let modal = document.querySelector('.v--modal-overlay')
        if (modal) {
          this.$bus.$emit('screen-width-changed')
        }
      }
    },

    tasks (t) {
      return {
        previewTermsTask: t(async function (subscriptionNumber, type) {
          this.trackConversion({ name: 'interaction', description: 'button:terms_&_conditions' })
          const apiEndpointBaseUrl = siteConfig.ApiHost
          const languageCode = detectedCulture.languageCode
          let downloadLink = document.createElement('a')
          downloadLink.style.display = 'none'
          downloadLink.target = '_blank'
          downloadLink.href = `${apiEndpointBaseUrl}/api/attachment/subscriptions/${subscriptionNumber}/terms-and-conditions/${type}?languageCode=${languageCode}`
          document.body.appendChild(downloadLink)
          downloadLink.click()

          setTimeout(() => {
            document.body.removeChild(downloadLink)
          }, 500)
        }).onError(function (task) {
          this.$notify({
            type: 'error',
            title: extractErrorMessage(task.error)
          })
        }),

        repairSubscriptionTask: t(async function () {
           await Vue.api.subscription.repair(this.subscriptionDetails.number)
          this.$router.replace({
            name: 'my-account'
          })
        }).onError(function (task) {
          this.$notify({
            type: 'error',
            title: extractErrorMessage(task.error)
          })
        }),

        resumeSubscription: t(async function () {
          if (this.subscriptionDetails.ableToResumeReplenishment) {
            await Vue.api.subscription.resumeSubscription(this.subscriptionNumber)
          } else if (this.subscriptionDetails.ableToChangeReplenishmentResumeDate) {
            await Vue.api.subscription.resumeSubscriptionWithResumeDate(this.subscriptionNumber, this.resumeDate)
          }
          await this.$store.dispatch('subscription/fetchSubscriptionDetails', this.subscriptionNumber)
          this.$emit('resume-success')
          this.$bus.$emit('close-modal', 'replenishmentResume')
        }).onError(function (task) {
          this.$notify({
            type: 'error',
            title: extractErrorMessage(task.error)
          })
        })
      }
    }
  }
</script>

<style lang="scss">
  .DetailsSection_accordion {
    .title-modify-subscription {
      font-size: .18rem;
      line-height: .22rem;
      font-weight: 500%;
      color: $font-gray;
      margin-bottom: .1rem;
    }

    .Tips {
      color: $blue;
      padding: 0 .1rem .15rem;
      font-size: .14rem;
      line-height: .22rem;

      @include media (tablet) {
        padding: 0 0 .2rem;
        font-size: .16rem;
        line-height: .24rem;
      }
    }

    .bundle-ratePlan {
      border: .01rem solid #979797;
      padding: .2rem .1rem;
      width: 100%;
      margin-bottom: .1rem;

      &_basicInfo {
        margin-bottom: .2rem;

        @include media(mobile) {
          min-height: 0 !important;
        }

        .Product {
          border: none;
          margin: 0;
          padding: 0;

          .img-holder {
            width: 1rem;
            height: 1rem;
            flex-shrink: 0;
          }

          &_info {
            padding: 0;
          }

          .info_item {
            font-size: .12rem;
            line-height: 1.5;

            &.Product_name {
              font-size: .18rem;
              line-height: 1.2;
              color: $font-gray;
            }

            &.Product_price {
              font-size: .14rem;
              line-height: .2rem;
              color: $blue;

              .has-discount {
                font-size: .12rem;

                &::before {
                  border-top: 0.01rem solid #0066a1;
                }
              }
            }
          }
        }
      }
    }

    .v--modal-box {
      color: #252525;

      .v--modal-container {
        .v--modal-content {
          .modal-content {
            .modal-button-warpper {
              margin-top: .1rem;
              display: flex;
              justify-content: space-between;

              .AppButton {
                width: 45%;
              }
            }
          }
        }
      }

      p {
        font-size: .16rem;
      }
    }

    .termsAndConditions {
      color: $blue;
      margin-bottom: .1rem;
    }

    .resumeSubscription {
      .modal-button {
        margin: .32rem 0 .1rem !important;
        justify-content: flex-end !important;

        .AppButton {
          width: auto !important;
          padding: .09rem .4rem;
        }

        .cancel_openModal {
          margin-right: .1rem;
          background-color: #fff;
          color: $blue;
        }
      }

      .modal-title {
        margin-top: .3rem !important;
      }
    }

    .pause_subscription {
      .subscription_button {
        cursor: pointer;
        background: rgba(0, 102, 161, .15);
        padding: .255rem .15rem;
        color: #0066a1;
        font-weight: 500;
        width: 100%;
        text-align: left;
        display: block;
        font-size: .14rem;
        margin-bottom: .14rem;
      }

      .pause_subscription-modal {
        .v--modal-background-click {
          .v--modal-box {
            .v--modal-container {
              .modal-title {
                line-height: .28rem;
                font-size: .2rem;
                color: #212121;
              }

              .v--modal-content {
                .modal-content {
                  .subTitle {
                    line-height: .2rem;
                    color: #212121;
                    font-weight: bold;
                    font-size: .16rem;
                  }

                  .modal-button-warpper {
                    .AppButton {
                      width: 100%;
                      margin-bottom: .1rem;
                      background-color: #1474a4;
                      padding: .09rem .4rem;
                      font-size: .16rem;
                      line-height: .22rem;
                    }

                    .AppButton:nth-of-type(2) {
                      background-color: #fff;
                      color: $blue;
                    }
                  }
                }
              }
            }
          }
        }
      }

      .payment-method_radio {
        display: flex;
        align-items: center;
        justify-content: center;
        height: .24rem;
        width: .24rem;
        background: transparent;
        border: .01rem solid #c4c4c4;
        border-radius: 50%;
        margin-right: .14rem;
      }

      .payment-method_radioExtend {
        display: flex;
        align-items: center;
        justify-content: center;
        height: .24rem;
        width: .24rem;
        background: transparent;
        border: .01rem solid #c4c4c4;
        border-radius: 50%;
        margin-right: .14rem;
        border-color: #1f78a7;

        &::after {
          content: "";
          width: .08rem;
          height: .08rem;
          display: block;
          background: #1f78a7;
          border-radius: 50%;
        }
      }

      .selectRadio {
        ul {
          li {
            cursor: pointer;
            line-height: .24rem;
            font-size: .16rem;
            word-spacing: -.001rem;
            color: #454545;
          }

          li:nth-of-type(1) {
            display: flex;
            margin-bottom: .16rem;
          }

          li:nth-of-type(2) {
            display: flex;
            margin-bottom: .32rem;

            span {
              max-width: 86%;
            }
          }
        }
      }
    }

    .return-information {
      padding: 0 .1rem;
      font-size: .14rem;
      line-height: .24rem;

      @include media(tablet) {
        font-size: .16rem;
        padding: 0;
      }

      p {
        font-weight: 700;
      }

      .bundlesCancelSubscription {
        .tips {
          font-weight: 400;
          font-size: .16rem;
          line-height: .24rem;
          margin: .06rem 0 .2rem;
        }

        .AppButton {
          width: auto;

          @include media(tablet) {
            min-width: 30%;
          }
        }
      }

      span {
        color: $font-black;
        font-weight: 500;
      }

      .cancel-description {
        color: $font-black;
        font-weight: 500;
        margin: .3rem 0;
      }
    }

    .startSubscription {
      p {
        background: rgba(0, 102, 161, .15);
        padding: .255rem .15rem;
        color: #0066a1;
        font-weight: 500;
        cursor: pointer;
        width: 100%;
        text-align: left;
        display: block;
        font-size: .14rem;
        margin-bottom: .14rem;
      }
    }

    .cancellation_subscription {
      .text {
        margin-bottom: .24rem;
      }

      .tips {
        font-size: .14rem;
        line-height: .21rem;
        color: #212121;
      }

      .cancelProcess {
        width: auto;
        margin-top: .24rem;

        @include media(tablet) {
          min-width: 30%;
        }
      }
    }

    .recycling_program {
      .tips {
        font-size: .14rem;
        line-height: .21rem;
        color: #212121;
      }

      a {
        color: $blue;
      }
    }
  }

  .TrackOrder {
    background-color: $white;
    font-size: .14rem;
    line-height: .22rem;
    padding: 0 .1rem;
    color: $blue;

    @include media(tablet) {
      padding: 0;
    }

    &_number {
      color: $blue;
      text-decoration: underline;
    }

    &_item {
      margin-bottom: .1rem;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .name {
      font-size: .14rem;
      font-weight: 500;
    }
  }
</style>
